module.exports = __webpack_public_path__ + "static/media/20.52592de3.JPG";